import UploadTab from './components/UploadTab';
import GlobalTabs from '../../components/Tabs';
import SolicitacoesTab from './components/SolicitacoesTab';
import StatusModalBody from './components/StatusModalBody';
import { useSelector } from 'react-redux';
import { stateGlobal } from '../../interfaces/Global';
import { Button, Modal, Tag } from 'antd';
import { useRecuperacaoReceitas } from './useRecuperacaoReceitas';
import { FileAddOutlined, UploadOutlined } from '@ant-design/icons';

const RecuperacaoReceitas: React.FC = () => {
    const propsState = useSelector((state: stateGlobal) => state.global);
    const {
        observacao,
        arrayStatus,
        isModalOpen,
        selectedRow,
        loadingTable,
        loadingUpload,
        selectedStatus,
        dataSolicitacao,
        loadingButtonId,
        dataUploadHistorico,
        closeModal,
        showModal,
        handleUpload,
        handleDownload,
        setObservacao,
        handleSaveFooter,
        setSelectedStatus,
        handleUpdateStatusSolicitacao,
    } = useRecuperacaoReceitas();

    return (
        <>
            <GlobalTabs
                defaultActiveKey="1"
                items={[
                    {
                        key: '1',
                        label: 'Solicitações',
                        icon: <FileAddOutlined />,
                        children: <SolicitacoesTab
                            showModal={showModal}
                            data={dataSolicitacao ?? []}
                            loadingTable={loadingTable}
                            themeState={propsState.theme}
                        />,
                    },
                    {
                        key: '2',
                        label: 'Importação',
                        icon: <UploadOutlined />,
                        children: <UploadTab
                            onUpload={handleUpload}
                            onDownload={handleDownload}
                            loading={loadingUpload}
                            loadingTable={loadingTable}
                            themeState={propsState.theme}
                            data={dataUploadHistorico ?? []}
                            loadingButtonId={loadingButtonId}
                        />,
                    },
                ]}
            />
            <Modal
                title={
                    <span>
                        Atualizar solicitação de{" "}
                        {selectedRow?.usuario_nome} -{" "}
                        {selectedRow?.contratos?.map((e) => (
                            <Tag
                                style={{ fontSize: 14 }}
                                key={e.id}
                            >
                                {e.nome}
                            </Tag>
                        ))}
                    </span>
                }
                open={isModalOpen}
                onCancel={closeModal}
                footer={[
                    <Button key="back" onClick={closeModal}>
                        Fechar
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        onClick={handleSaveFooter}
                        disabled={(!selectedStatus || selectedStatus === selectedRow?.status) && !observacao}
                        loading={loadingButtonId === selectedRow?._id}
                    >
                        Salvar
                    </Button>
                ]}
                width={800}
                destroyOnClose
            >
                <StatusModalBody
                    data={selectedRow}
                    closeModal={closeModal}
                    observacao={observacao}
                    arrayStatus={arrayStatus}
                    themeState={propsState.theme}
                    setObservacao={setObservacao}
                    selectedStatus={selectedStatus}
                    loadingButtonId={loadingButtonId}
                    setSelectedStatus={setSelectedStatus}
                    updateStatus={handleUpdateStatusSolicitacao}
                />
            </Modal>
        </>
    );
};

export default RecuperacaoReceitas;
